(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-countdown"] && !Shopify.designMode) return;
  try {
    

class NeonSaleCountdown {

  constructor(element) {

    this.element = element;

    this.days =
      element.querySelector(
        '[data-days]'
      );

    this.hours =
      element.querySelector(
        '[data-hours]'
      );

    this.minutes =
      element.querySelector(
        '[data-minutes]'
      );

    this.seconds =
      element.querySelector(
        '[data-seconds]'
      );

    this.displayDate =
      element.querySelector(
        '[data-display-date]'
      );

    this.content =
      element.querySelector(
        '[data-countdown-content]'
      );

    this.expired =
      element.querySelector(
        '[data-countdown-expired]'
      );


    this.date =
      element.dataset.date;


    this.time =
      element.dataset.time ||
      '23:59';


    this.timezone =
      element.dataset.timezone ||
      '+05:30';


    this.dateOverride =
      element.dataset.dateOverride ||
      '';


    this.hideExpired =
      element.dataset.hideExpired ===
      'true';


    this.interval = null;


    this.init();

  }


  init() {

    if (!this.date) {
      return;
    }


    this.setDisplayDate();


    const targetString =
      `${this.date}T${this.time}:00${this.timezone}`;


    this.target =
      new Date(
        targetString
      ).getTime();


    if (
      Number.isNaN(
        this.target
      )
    ) {

      console.warn(
        'Neon Sale Countdown: Invalid end date or time.',
        targetString
      );

      return;

    }


    this.update();


    this.interval =
      window.setInterval(
        () => {
          this.update();
        },
        1000
      );

  }


  setDisplayDate() {

    if (!this.displayDate) {
      return;
    }


    /*
      If merchant manually entered
      a display date, use it.
    */

    if (
      this.dateOverride.trim() !== ''
    ) {

      this.displayDate.textContent =
        this.dateOverride;

      return;

    }


    /*
      Otherwise automatically turn
      2026-08-15 into
      15 AUGUST 2026.
    */

    const parts =
      this.date.split('-');


    if (parts.length !== 3) {
      return;
    }


    const year =
      Number(parts[0]);

    const month =
      Number(parts[1]);

    const day =
      Number(parts[2]);


    const dateObject =
      new Date(
        Date.UTC(
          year,
          month - 1,
          day
        )
      );


    if (
      Number.isNaN(
        dateObject.getTime()
      )
    ) {
      return;
    }


    const formatted =
      new Intl.DateTimeFormat(
        'en-IN',
        {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          timeZone: 'UTC'
        }
      )
      .format(
        dateObject
      )
      .toUpperCase();


    this.displayDate.textContent =
      formatted;

  }


  format(value) {

    return String(
      value
    ).padStart(
      2,
      '0'
    );

  }


  update() {

    const now =
      Date.now();


    const distance =
      this.target -
      now;


    if (
      distance <= 0
    ) {

      this.complete();

      return;

    }


    const millisecondsPerDay =
      1000 *
      60 *
      60 *
      24;


    const millisecondsPerHour =
      1000 *
      60 *
      60;


    const millisecondsPerMinute =
      1000 *
      60;


    const days =
      Math.floor(
        distance /
        millisecondsPerDay
      );


    const hours =
      Math.floor(
        (
          distance %
          millisecondsPerDay
        ) /
        millisecondsPerHour
      );


    const minutes =
      Math.floor(
        (
          distance %
          millisecondsPerHour
        ) /
        millisecondsPerMinute
      );


    const seconds =
      Math.floor(
        (
          distance %
          millisecondsPerMinute
        ) /
        1000
      );


    if (this.days) {
      this.days.textContent =
        this.format(days);
    }


    if (this.hours) {
      this.hours.textContent =
        this.format(hours);
    }


    if (this.minutes) {
      this.minutes.textContent =
        this.format(minutes);
    }


    if (this.seconds) {
      this.seconds.textContent =
        this.format(seconds);
    }

  }


  complete() {

    if (this.interval) {

      window.clearInterval(
        this.interval
      );

      this.interval = null;

    }


    if (this.days) {
      this.days.textContent =
        '00';
    }


    if (this.hours) {
      this.hours.textContent =
        '00';
    }


    if (this.minutes) {
      this.minutes.textContent =
        '00';
    }


    if (this.seconds) {
      this.seconds.textContent =
        '00';
    }


    if (
      this.hideExpired
    ) {

      this.element.style.display =
        'none';

      return;

    }


    if (this.content) {

      this.content.hidden =
        true;

    }


    if (this.expired) {

      this.expired.hidden =
        false;

    }

  }

}


function initializeNeonSaleCountdowns(
  container = document
) {

  const countdowns =
    container.querySelectorAll(
      '[data-neon-countdown]'
    );


  countdowns.forEach(
    (element) => {

      if (
        element.dataset
          .neonCountdownInitialized ===
        'true'
      ) {
        return;
      }


      element.dataset
        .neonCountdownInitialized =
        'true';


      new NeonSaleCountdown(
        element
      );

    }
  );

}


initializeNeonSaleCountdowns();


document.addEventListener(
  'shopify:section:load',
  (event) => {

    initializeNeonSaleCountdowns(
      event.target
    );

  }
);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
